export enum DocumentType {
  FOLDER = 'FOLDER',
  DOCUMENT = 'DOCUMENT'
}
